module.exports = __webpack_public_path__ + "static/media/IMG_2527.5bb80f81.jpg";